import { initializeApp, FirebaseApp } from "firebase/app";
import { getAnalytics, logEvent, Analytics } from "firebase/analytics";
import { getAuth, Auth } from "firebase/auth";
import { getDatabase, Database } from "firebase/database";
import { getStorage, FirebaseStorage } from "firebase/storage";
import { getFirestore, Firestore } from "firebase/firestore";
import { getPerformance, FirebasePerformance } from "firebase/performance";

// Firebase configuration with environment fallback
const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY || "AIzaSyAtuFQKhs2znYEI3GwA34FoAszH-XrjQvo",
  authDomain: process.env.FIREBASE_AUTH_DOMAIN || "great-child.firebaseapp.com",
  projectId: process.env.FIREBASE_PROJECT_ID || "great-child",
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET || "great-child.firebasestorage.app",
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "316553323254",
  appId: process.env.FIREBASE_APP_ID || "1:316553323254:web:96246027bc627efce842d7",
  measurementId: process.env.FIREBASE_MEASUREMENT_ID || "G-R4DT7PMSRY",
  databaseURL: process.env.FIREBASE_DATABASE_URL || "https://great-child-default-rtdb.europe-west1.firebasedatabase.app/"
};

// Initialize Firebase App
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth: Auth = getAuth(app);
const database: Database = getDatabase(app);
const storage: FirebaseStorage = getStorage(app);
const firestore: Firestore = getFirestore(app);
const perf: FirebasePerformance = getPerformance(app);

// Analytics is only available in browser environments
let analytics: Analytics | undefined;
/* global globalThis */
if (typeof globalThis.window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Bundle exports into a single object
export interface FirebaseServices {
  app: FirebaseApp;
  auth: Auth;
  database: Database;
  storage: FirebaseStorage;
  firestore: Firestore;
  perf: FirebasePerformance;
  analytics?: Analytics;
  logEvent: (analyticsInstance: Analytics, eventName: string, eventParams?: { [key: string]: any }) => void;
}

const firebaseServices: FirebaseServices = {
  app,
  auth,
  database,
  storage,
  firestore,
  perf,
  analytics,
  logEvent
};

export default firebaseServices;
export { app, auth, database, storage, firestore, perf, analytics, logEvent };
